// extracted by mini-css-extract-plugin
module.exports =  {"pf-label":"pf-label--DcXby","pfLabel":"pf-label--DcXby"};